import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import Chatbot from "../Chatbot";
import BnrSocialLinks from "./BnrSocialLinks";
import logoLight from "../../assets/images/bnr-logo.png";
import "./NavbarBnr.css";

/** Which BNR-style tab should show the active (white + blue bar) state */
function getBnrNavKey(pathname) {
  const p = pathname.toLowerCase();
  if (p === "/aboutus" || p.startsWith("/aboutus/")) return "about";
  if (p === "/monetarypolicy" || p.startsWith("/monetarypolicy/")) return "monetary";
  if (
    ["/esstatistics", "/fsstatistics", "/ecostatistics", "/psstatistics", "/mstatistics", "/statistics"].some(
      (x) => p === x || p.startsWith(x + "/")
    )
  )
    return "statistics";
  if (
    p === "/publications" ||
    p.startsWith("/publications/") ||
    p === "/newsmain" ||
    p.startsWith("/newsmain/") ||
    p.startsWith("/newsdetails")
  )
    return "news";
  if (p === "/service" || p.startsWith("/service/") || p === "/servicedetails" || p.startsWith("/servicedetails/"))
    return "services";
  return null;
}

function setGoogleTranslateCookie(langCode) {
  const value = `/en/${langCode}`;
  document.cookie = `googtrans=${value};path=/`;
  document.cookie = `googtrans=${value};path=/;domain=${window.location.hostname}`;
}

const Navbar = () => {
  const [mobile, setmobile] = useState(false);
  const [servicesDrop, setservicesDrop] = useState(false);
  const [newsPubDrop, setNewsPubDrop] = useState(false);
  const [lang, setLang] = useState(() => localStorage.getItem("bnr_lang") || "en");
  const location = useLocation();
  const path = location.pathname;
  const bnrKey = getBnrNavKey(path);

  const headerRef = useRef(null);
  const spacerRef = useRef(null);

  useEffect(() => {
    const header = headerRef.current;
    const spacer = spacerRef.current;
    if (!header || !spacer) return;

    const syncHeight = () => {
      spacer.style.height = `${header.offsetHeight}px`;
    };

    syncHeight();
    requestAnimationFrame(() => requestAnimationFrame(syncHeight));
    const ro = new ResizeObserver(syncHeight);
    ro.observe(header);
    window.addEventListener("resize", syncHeight);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", syncHeight);
    };
  }, [path]);

  useEffect(() => {
    window.scroll(0, 0);
  }, [path]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.googleTranslateElementInit = () => {
      if (!window.google || !window.google.translate) return;
      if (window.__bnrTranslateReady) return;
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,fr,rw",
          autoDisplay: false,
        },
        "google_translate_element"
      );
      window.__bnrTranslateReady = true;
    };

    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google && window.google.translate && !window.__bnrTranslateReady) {
      window.googleTranslateElementInit();
    }
  }, []);

  const onLanguageChange = (event) => {
    const next = event.target.value;
    setLang(next);
    localStorage.setItem("bnr_lang", next);
    setGoogleTranslateCookie(next);
    window.location.reload();
  };

  return (
    <>
      <div ref={headerRef} className="page-wrapper-header bnr-page-header">
        <div id="google_translate_element" className="bnr-google-translate-root" />
        <nav className="main-menu main-menu--bnr">
          <div className="container bnr-header-branding py-2">
            <div className="row align-items-center">
              <div className="col-lg-5 col-8">
                <Link to="/" className="title1 bnr-header-branding__link">
                  <img
                    src={logoLight}
                    alt=""
                    className="bnr-header-branding__logo"
                    width="60"
                    height="60"
                    decoding="async"
                  />
                  <span className="bnr-header-branding__title-text">National Bank of Rwanda</span>
                </Link>
              </div>
              <div className="col-lg-5 col-xl-7 d-none d-lg-block bnr-header-util">
                <div className="bnr-header-util__group">
                  <Link to="/contact">Contact</Link>
                  <span className="bnr-header-util__sep">|</span>
                  <Link to="/careers">Careers</Link>
                  <BnrSocialLinks />
                </div>
                {/* <span className="bnr-header-util__sep">|</span>
                <label className="bnr-header-lang-label" htmlFor="bnr-language-select">
                  Language:
                </label>
                <select id="bnr-language-select" className="bnr-header-lang-select" value={lang} onChange={onLanguageChange}>
                  <option value="en">English</option>
                  <option value="fr">French</option>
                  <option value="rw">Kinyarwanda</option>
                </select> */}
              </div>
              <div className="col-lg-2 col-4 text-end d-xl-none">
                <div className="main-menu__right justify-content-end">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setmobile(true);
                    }}
                    className="main-menu__toggler mobile-nav__toggler"
                    aria-label="Open menu"
                  >
                    <i className="fa fa-bars"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="bnr-nav-strip d-none d-xl-block">
            <div className="container">
              <div className="main-menu__nav">
                <ul className="main-menu__list main-menu__list--bnr">
                 
                  <li
                    className={`mega-dropdown ${bnrKey === "about" ? "bnr-nav-item--active" : ""}`}
                  >
                    <Link to="#">About</Link>
                    <div className="mega-menu">
                        <div className="mega-menu-column documentation-card-header">
                        <h3>Our People</h3>
                        <p>
                          <ol>
                            <li>
                              <Link to="/aboutus">About Us</Link>
                            </li>
                            <li>
                              <Link to="/contact">Contact Us</Link>
                            </li>
                            <li>
                              <Link to="/careers">Careers</Link>
                            </li>
                          </ol>
                        </p>
                      </div>
                      <div className="mega-menu-column documentation-card-header">
                        <h3>Who We Are </h3>
                        <p>
                          <ol>
                            <li>
                              <Link to="/Board">Board Members</Link>
                            </li>
                            <li>
                              <Link to="/directors">Executive Directors</Link>
                            </li>
                            <li>
                              <Link to="/employee">Employee of the Year</Link>
                            </li>
                          </ol>
                        </p>
                      </div>
                    
                    </div>
                  </li>

                  <li className={`dropdown ${bnrKey === "monetary" ? "bnr-nav-item--active" : ""}`}>
                    <Link to="/MonetaryPolicy">Monetary Policy</Link>
                  </li>

                  <li
                    className={`mega-dropdown ${bnrKey === "statistics" ? "bnr-nav-item--active" : ""}`}
                  >
                    <Link to="#">Statistics</Link>
                    <div className="mega-menu">
                      <div className="mega-menu-column documentation-card-header">
                        <h3>About Our Statistics</h3>
                        <p style={{ textAlign: "justify" }}>
                          This section provides key statistics on Rwanda&apos;s external sector, financial sector
                          and economy.
                        </p>
                      </div>
                      <div className="mega-menu-column documentation-card-header">
                        {/* <h3>Related links</h3> */}
                        <p>
                          <ol>
                            <li>
                              <Link to="/esstatistics">External Sector Statistics</Link>
                            </li>
                            <li>
                              <Link to="/fsstatistics">Financial Sector Statistics</Link>
                            </li>
                            <li>
                              <Link to="/ecostatistics">Economic Statistics</Link>
                            </li>
                            <li>
                              <Link to="/psstatistics">Payment System Statistics</Link>
                            </li>
                            <li>
                              <Link to="/mstatistics">Monetary Statistics</Link>
                            </li>
                          </ol>
                        </p>
                      </div>
                    </div>
                  </li>

                  <li className={`dropdown ${bnrKey === "news" ? "bnr-nav-item--active" : ""}`}>
                    <Link to="/Publications">Publications</Link>
                  </li>
   <li
                    className={`mega-dropdown ${bnrKey === "services" ? "bnr-nav-item--active" : ""}`}
                  >
                    <Link to="#">Services</Link>
                    <div className="mega-menu">
                      <div className="mega-menu-column documentation-card-header">
                        <h3>Our Services</h3>
                        <p>
                        NBR delivers all its services through the E-Correspondence
                        Portal; a secure, interactive, and paperless online platform that
                        enables stakeholders to conveniently access customer services,
                        submit applications, and manage all required documentation electronically..
                        </p>
                        <p>
                         <a
                  href="https://e-correspondence.bnr.rw/services"
                  target="_blank"
                  rel="noreferrer">Click here to access our services</a>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <div ref={spacerRef} className="bnr-header-spacer" aria-hidden="true" />

      <div className={`mobile-nav__wrapper ${mobile ? "expanded" : ""}`}>
        <div className="mobile-nav__overlay mobile-nav__toggler" onClick={() => setmobile(false)}></div>
        <div className="mobile-nav__content">
          <span className="mobile-nav__close mobile-nav__toggler" onClick={() => setmobile(false)}>
            <i className="fa fa-times"></i>
          </span>

          <div className="logo-box">
            <Link to="/" aria-label="logo image" onClick={() => setmobile(false)}>
              <img src={logoLight} width="155" alt="" />
            </Link>
          </div>

          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li className="current">
                <Link to="/" onClick={() => setmobile(false)}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/aboutus" onClick={() => setmobile(false)}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/MonetaryPolicy" onClick={() => setmobile(false)}>
                  Monetary Policy
                </Link>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  className={servicesDrop ? "expanded" : ""}
                  onClick={(e) => e.preventDefault()}
                >
                  Statistics
                  <button
                    type="button"
                    aria-label="Statistics submenu"
                    className={servicesDrop ? "expanded" : ""}
                    onClick={() => setservicesDrop(!servicesDrop)}
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                {servicesDrop && (
                  <ul style={{ display: "block" }}>
                    <li>
                      <Link to="/esstatistics" onClick={() => setmobile(false)}>
                        External Sector Statistics
                      </Link>
                    </li>
                    <li>
                      <Link to="/fsstatistics" onClick={() => setmobile(false)}>
                        Financial Sector Statistics
                      </Link>
                    </li>
                    <li>
                      <Link to="/ecostatistics" onClick={() => setmobile(false)}>
                        Economic Statistics
                      </Link>
                    </li>
                    <li>
                      <Link to="/psstatistics" onClick={() => setmobile(false)}>
                        Payment System Statistics
                      </Link>
                    </li>
                    <li>
                      <Link to="/mstatistics" onClick={() => setmobile(false)}>
                        Monetary Statistics
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  className={newsPubDrop ? "expanded" : ""}
                  onClick={(e) => e.preventDefault()}
                >
                  Publications
                  <button
                    type="button"
                    aria-label="News and publications submenu"
                    className={newsPubDrop ? "expanded" : ""}
                    onClick={() => setNewsPubDrop(!newsPubDrop)}
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                {newsPubDrop && (
                  <ul style={{ display: "block" }}>
                    <li>
                      <Link to="/Publications" onClick={() => setmobile(false)}>
                        Publications
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link to="/contact" onClick={() => setmobile(false)}>
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href="https://e-correspondence.bnr.rw/services"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => setmobile(false)}
                >
                  Our services
                </a>
              </li>
            </ul>
          </div>

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="icon-email"></i>
              <Link to="mailto:info@bnr.rw">info@bnr.rw</Link>
            </li>
            <li>
              <i className="icon-telephone"></i>
              <Link to="tel:+250788199000">+ (250) 788199000 </Link>
            </li>
          </ul>

          <BnrSocialLinks className="mobile-nav__social" />
        </div>
      </div>

      <div>
        <Chatbot />
      </div>
    </>
  );
};

export default Navbar;
